export default "__VITE_ASSET__fdf662c9__"